import {
  ImageWithMetadata,
  resizeToWidth,
  ImageProps,
} from '@features/powerpoint';

type CenterImageOptions = {
  image: ImageWithMetadata;
  maxWidth: number;
  maxHeight: number;
  x: number;
  y: number;
};

export const centeredImage = (options: CenterImageOptions): ImageProps => {
  const resizedImage = resizeToWidth(
    options.image,
    options.maxWidth,
    options.maxHeight
  );

  return {
    data: resizedImage.data,
    x: options.x + options.maxWidth / 2 - resizedImage.width / 2,
    y: options.y + options.maxHeight / 2 - resizedImage.height / 2,
    w: resizedImage.width,
    h: resizedImage.height,
  };
};
